import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService, environment, MyHttpClientFactory } from '@ups/xplat/core';
import { ShipmentDocumentStatus } from '@ups/tool-tracker';

@Injectable({
  providedIn: 'root',
})
export class ShipmentDocumentService extends DataService<unknown> {
  route: string;

  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/shipmentDocumentStatus',
      httpClient,
      httpFactory
    );
  }

  getStatuses(): Observable<ShipmentDocumentStatus[]> {
    return this.httpClient.get<ShipmentDocumentStatus[]>(`${this.route}`);
  }
}
